import { useState, useEffect } from "react";
import styles from "../index.less";
import Blank from "../components/blank";
import { clearHtmlTag } from "utils";
import Template from "../components/template";
import { setHospitalTDK } from "utils/hospital";

// 医生主页
const Hospital = () => {

  return (
    <Template breadTitle="详细介绍">
      {
        (hospitalInfo: any) => {
          setHospitalTDK(
            `${hospitalInfo?.hospitalName}简介_电话_地址 - 京东健康互联网医院`,
            `${hospitalInfo?.hospitalName}电话,${hospitalInfo?.hospitalName}地址,${hospitalInfo?.hospitalName}介绍`,
            `${hospitalInfo?.introduction?.slice(0,100)}`
          );
          return (
            <>
              <Blank className={styles.hospitalConcat} title="医院地址与电话">
                <div className={styles.address}>
                  <div className={styles.subTitle}>医院地址</div>
                  <div className={styles.desc}>
                    {hospitalInfo?.address || '暂无地址信息'}
                  </div>
                </div>
                <div className={styles.phone}>
                  <div className={styles.subTitle}>医院电话</div>
                  <div className={styles.desc}>
                    {hospitalInfo?.formattedPhoneList?.length > 0 ? hospitalInfo?.formattedPhoneList?.map((item: any) => (
                      <div className={styles.descStr}>{item.str}</div>
                    )) : <>暂无联系方式</>}
                  </div>
                </div>
              </Blank>
              {/* 医院介绍 */}
              <div className={styles.hospitalContent} dangerouslySetInnerHTML={{
                __html: hospitalInfo.introduction,
              }} />
            </>
          )
        }
      }
    </Template>
  );
};

export default Hospital;